module.exports = __webpack_public_path__ + "img/bag_increase.7de7ec6f.png";